import { useAudioController } from '@store/audio/AudioController';
import { togglePlayPause } from '@store/audio/AudioEngineHTML5';
import { setPlaylistUpNext } from '@store/audio/AudioFetcher';

export function usePlaylistPlayingState({ playlistId }: { playlistId: string }) {
  const { playing, activePlaylistId, loading } = useAudioController();

  const isActivePlaylist = playlistId === activePlaylistId;

  const isPlaying = isActivePlaylist && playing;

  const onPlayButtonClick = () => {
    if (isActivePlaylist) {
      togglePlayPause();
    } else {
      setPlaylistUpNext(playlistId);
    }
  };

  return {
    isPlaying,
    isActivePlaylist,
    loading: loading && isActivePlaylist,
    onPlayButtonClick,
  };
}
